import { CMSContent } from 'models/cms';

const cmsContentSortByPriority = ((a: CMSContent, b: CMSContent): number => {
  // Both have priority
  if (a.priority != null && b.priority != null) {
    return a.priority - b.priority;
  }
  // Only a has priority
  if (a.priority != null && b.priority == null) {
    return -1;
  }
  // Only b has priority
  if (a.priority == null && b.priority != null) {
    return 1;
  }
  // Both priorities are null/undefined, order by startDate desc
  const dateA = new Date(a.startDate ?? 0);
  const dateB = new Date(b.startDate ?? 0);
  return dateB.getTime() - dateA.getTime();
});

export default cmsContentSortByPriority;